<template>
  <div class="offer bg-grey-lighten-2">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="5" class="text-center" style="margin: auto">
          <v-container class="cont-page">
            <v-card class="card" color="blue">
              <div class="offer-text">Most Popular</div>
              <v-card-item style="margin-top: 30px">
                <v-card-title class="title-center font-weight-bold">
                  Black Friday offers
                </v-card-title>
                <v-card-text class="text-center" style="margin-top: 10px">
                  <span class="text-start">
                    Offers and discounts on the occasion of Black Friday on all
                    platform products</span
                  >
                  <v-divider
                    style="margin-top: 20px; margin-bottom: 20px"
                  ></v-divider>
                  <span class="text-end">
                    Choose your offer now from entertainment devices or
                    electronic devices and.....</span
                  >
                </v-card-text>
              </v-card-item>
            </v-card>
          </v-container>
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="d-flex justify-center pl-10"
          style="margin: auto"
        >
          <v-carousel
            class="carousel-img"
            height="300"
            cycle
            interval="6000"
            show-arrows="hover"
            hide-delimiters
          >
            <template v-slot:prev="{ props }">
              <v-btn color="blue" v-bind="props"
                ><v-icon>mdi-arrow-left-bold</v-icon></v-btn
              >
            </template>
            <template v-slot:next="{ props }">
              <v-btn color="blue" v-bind="props"
                ><v-icon>mdi-arrow-right-bold</v-icon></v-btn
              >
            </template>
            <v-carousel-item v-for="(item, i) in items" :key="i">
              <v-img :src="item.src"></v-img>
            </v-carousel-item>
          </v-carousel>
        </v-col>
        <v-col cols="12" md="6" class="text-center">
          <v-hover v-slot="{ isHovering, props }">
            <div
              v-bind="props"
              class="cont-image"
              style="width: 100%; overflow: hidden"
            >
              <img
                :style="`width: 100%; max-width: 600px; cursor: pointer; transition: 0.4s all ease; transform: scale(${
                  isHovering ? 1.05 : 1
                })`"
                src="../../images/iphones.webp"
                alt=""
              />
            </div>
          </v-hover>
        </v-col>
        <v-col cols="12" md="6" class="text-center">
          <v-hover v-slot="{ isHovering, props }">
            <div
              v-bind="props"
              class="cont-image"
              style="width: 100%; overflow: hidden"
            >
              <img
                :style="`width: 100%; max-width: 600px; cursor: pointer; transition: 0.4s all ease; transform: scale(${
                  isHovering ? 1.05 : 1
                })`"
                src="../../images/laptops.webp"
                alt=""
              />
            </div>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
import { ref } from "vue";

const items = ref([
  { src: new URL("@/images/chairs.webp", import.meta.url).href },
  { src: new URL("@/images/playstations.webp", import.meta.url).href },
  { src: new URL("@/images/headset.webp", import.meta.url).href },
]);
</script>

<style scoped lang="css">
@media (min-width: 1200px) {
  .offer .card {
    height: 300px;
  }
  .offer .card .offer-text {
    top: -2px;
    margin-right: -8px;
  }
}
@media (max-width: 990px) {
  .offer .card {
    width: 90%;
    margin: auto;
    padding: 10px;
    height: 265px;
  }

  .offer .card .offer-text {
    top: -2px;
  }
}
@media (max-width: 480px) {
  .offer .card {
    padding: 10px;
  }
  .offer .carousel-img {
    margin-right: 28px;
    margin-bottom: -85px;
  }
  .offer .card .offer-text {
    margin-right: -4px;
  }
}
@media (min-width: 480px) and (max-width: 767px) {
  .offer .carousel-img {
    margin-right: 28px;
  }
}
.offer .card {
  position: relative;
}
.offer .card .offer-text {
  position: absolute;

  writing-mode: vertical-rl;
  background-color: #ffc107;
  color: black;
  font-weight: bold;
  padding: 5px 10px 25px 10px;
  font-size: 13px;
  right: 10px;
  width: 40px;
}
.offer .card .offer-text::before {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  border-style: solid;
  border-color: transparent transparent #2196f3;
  border-width: 20px;
}
</style>
